import "./style/globals.css";
import "./style/animations.css";

import Providers from "./store/Provider";
import { getQueryParamFromUrl } from "./helpers/url";
import { scrollToSection } from "./helpers/scroll";
import { useEffect } from "react";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import ModalLayout from "./Modals/ModalLayout/ModalLayout";
import PageLayout from "./pages/layout/PageLayout";
import { Route, Routes } from "react-router";
import Cookies from "js-cookie";

function App() {
  const params = getQueryParamFromUrl();
  useEffect(() => {
    if (params.scroll && params.scroll === "1") {
      setTimeout(() => {
        scrollToSection("#section-2");
      }, 500);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const isNewApiEnabled = urlParams.get("new-api") === "true";
    if (isNewApiEnabled) Cookies.set("new-api", "true");
    
  }, []);
  // id: "GTM-PN2Q4QJ"
  const gtmParams = { id: "GTM-PN2Q4QJ" };
  return (
    <Providers>
      <GTMProvider state={gtmParams}>
        <ModalLayout />
        <Routes>
          <Route path="/banigame/banichance_s1404" element={<PageLayout />} />
          <Route
            path="/*"
            element={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "100vh",
                  direction: "ltr",
                  fontSize: "20px",
                  color: "#fff",
                }}
              >
                404 Page
              </div>
            }
          />
        </Routes>
      </GTMProvider>
    </Providers>
  );
}
export default App;
